import {
  clearTimeouts,
  engine as anime,
} from "../../../../../animations/index";
import { getTemplateDurationOveride } from "../../../../shared/utils/timeline";

const timeouts = []; 

const main = (props) => {
  const timeouts = [];
  const { id, format, templateName, data } = props;
  const timeline = anime.timeline();

  const templateDuration = 10; // for bild templates we use 5
  $(`#${id} .ant-progress-bg`).css("width", "100%");
  $(`#${id} .ant-progress-bg`).css(
    "transition-duration",
    `${templateDuration}s`,
  );

  const video = $(`#${id} video.video-pitch`).get(0);
  video.currentTime = 0;
  video.play();

  anime({
    targets: [`#${id} .left-block-side`],
    rotateY: ["-50deg", 0],
    easing: "easeInOutQuad",
    duration: 1000,
    delay: 100
  })

  anime({
    targets: [`#${id} .left-block-shadow`],
    width: ["92px", "1px"],
    easing: "easeInOutQuad",
    duration: 1000,
    delay: 100
  })


  // anime({
  //   targets: [`#${id} .comp-arrow-container`],
  //   duration: 700,
  //   easing: "easeOutQuint",
  //   translateY: [1000, 0],
  //   opacity: [1, 1],
  //   delay: anime.stagger(150),
  // });

  // anime({
  //   targets: [`#${id} .hotzone-fade-in`],
  //   duration: 700,
  //   easing: 'linear',
  //   opacity: [0, 1],
  //   delay: 2000
  // });

  anime({
    targets: [`#${id} .bild-hotzone-arrows-right`],
    opacity: [0, 0.2],
    duration: 700,
    easing: 'easeInOutQuad',
    delay: 2500
  });

  return {
    timeline: [],
    timeouts,
  };
};

//clean up function, unmounting
export const animationCleanUp = (animationReturn) => {
  const { timeouts } = animationReturn;
  clearTimeouts(timeouts);
};

export default main;
